var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 110,
    viewBox: "0 0 210 110",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n      .node-rect {\r\n        fill: #2ecc71; /* Color verde de la imagen */\r\n        rx: 4;         /* Bordes redondeados */\r\n        ry: 4;\r\n      }\r\n      .node-text {\r\n        fill: white;\r\n        font-family: Arial, sans-serif;\r\n        font-weight: bold;\r\n        text-anchor: middle;\r\n      }\r\n      .node-text-main { font-size: 10px; }\r\n      .node-text-sub { font-size: 11px; }\r\n      .conn-line {\r\n        stroke: #2ecc71; /* Mismo verde para las l\xEDneas */\r\n        stroke-width: 2;\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "connections"
  }, /*#__PURE__*/React.createElement("path", {
    className: "conn-line",
    d: "M105,35 L45,75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "conn-line",
    d: "M105,35 L105,75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "conn-line",
    d: "M105,35 L165,75"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,15)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node-rect",
    width: 40,
    height: 20
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 13.5,
    className: "node-text node-text-main"
  }, "SWITCH"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,75)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node-rect",
    width: 30,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 11,
    className: "node-text node-text-sub"
  }, "C1"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,75)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node-rect",
    width: 30,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 11,
    className: "node-text node-text-sub"
  }, "C2"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,75)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "node-rect",
    width: 30,
    height: 15
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 11,
    className: "node-text node-text-sub"
  }, "C3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdd);
export default __webpack_public_path__ + "static/media/odd.6000ef8100c1096e8bfb4667edee6622.svg";
export { ForwardRef as ReactComponent };